// TODO: cleanup this component.
// Either separate variant/default or change all instances to variant
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { get } from 'lodash'
import { Flex, Tooltip, Box, Hide } from 'pcln-design-system'
import { Bag, Seat, Restaurant, Wifi, Calendar, DollarCircle, Luggage } from 'pcln-icons'

import StrikeThrough from '../../StrikeThrough'
import airTheme from '../../AirThemeProvider/airTheme'
import INCLUSION_RULES from '../inclusionRules'
import SUPPORTED_AMENITIES from '../supportedAmenities'
import { ComposedIcon } from '../../Icons'

const icons = {
  [SUPPORTED_AMENITIES.CARRY_ON.name]: {
    attributeName: 'bag',
    icon: Bag,
  },
  [SUPPORTED_AMENITIES.CHECKED_BAG.name]: {
    attributeName: 'luggage',
    icon: Luggage,
  },
  [SUPPORTED_AMENITIES.MEALS.name]: {
    attributeName: 'restaurant',
    icon: Restaurant,
  },
  [SUPPORTED_AMENITIES.SEATS.name]: {
    attributeName: 'seatEconomy',
    icon: Seat,
  },
  [SUPPORTED_AMENITIES.WIFI.name]: {
    attributeName: 'wifi',
    icon: Wifi,
  },
  [SUPPORTED_AMENITIES.REBOOKING.name]: {
    attributeName: 'calendar',
    icon: Calendar,
  },
  [SUPPORTED_AMENITIES.REFUND.name]: {
    attributeName: 'dollarCircle',
    icon: DollarCircle,
  },
  bag: {
    attributeName: 'bag',
    icon: Bag,
  },
  luggage: {
    attributeName: 'luggage',
    icon: Luggage,
  },
  restaurant: {
    attributeName: 'restaurant',
    icon: Restaurant,
  },
  seatEconomy: {
    attributeName: 'seatEconomy',
    icon: Seat,
  },
  seat: {
    attributeName: 'seat',
    icon: Seat,
  },
  wifi: {
    attributeName: 'wifi',
    icon: Wifi,
  },
  calendar: {
    attributeName: 'calendar',
    icon: Calendar,
  },
  dollarCircle: {
    attributeName: 'dollarCircle',
    icon: DollarCircle,
  },
}

const StyledTooltip = styled(Tooltip)`
  bottom: 10px;
  left: 9px;
  z-index: 10;

  ${(props) => get(props, 'theme.flyQueries.tablet')} {
    white-space: nowrap;
  }
`

const ICON_COLOR = 'text'

const textConstants = {
  INCLUDED_TEXT: 'Included',
  NOT_INCLUDED_TEXT: 'Not Included',
  CHARGEABLE_TEXT: 'Available for purchase',
}

const textConstantsSentence = {
  INCLUDED_TEXT: 'included',
  NOT_INCLUDED_TEXT: 'not included',
  CHARGEABLE_TEXT: 'available for purchase',
}

export default class AmenityIcon extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showTooltip: false,
    }

    AmenityIcon.getTooltip = AmenityIcon.getTooltip.bind(this)
    this.hideTooltip = this.hideTooltip.bind(this)
    this.showTooltip = this.showTooltip.bind(this)
  }

  static getTooltip(description, inclusion, useSentenceText) {
    const textOptions = useSentenceText ? textConstantsSentence : textConstants
    let inclusionText

    switch (inclusion) {
      case INCLUSION_RULES.CHARGEABLE.name:
        inclusionText = textOptions.CHARGEABLE_TEXT
        break

      case INCLUSION_RULES.INCLUDED.name:
        inclusionText = textOptions.INCLUDED_TEXT
        break

      default:
        inclusionText = textOptions.NOT_INCLUDED_TEXT
    }

    if (description && description.toLowerCase().includes('wifi')) {
      inclusionText = 'available'
    }
    const text = useSentenceText ? `${description} ${inclusionText}` : `${description}: ${inclusionText}`

    return (
      <StyledTooltip bg={'background.darkest'} color={'text.lightest'} top center>
        {text}
      </StyledTooltip>
    )
  }

  hideTooltip() {
    this.setState({
      showTooltip: false,
    })
  }

  showTooltip() {
    this.setState({
      showTooltip: true,
    })
  }

  render() {
    const {
      isBrandedFaresVariant,
      name,
      included,
      inclusion,
      size,
      description,
      strikeThroughColor,
      allowHorizontalAlignment,
      useSentenceText,
      disableTooltip,
    } = this.props

    // Only render if valid name provided
    if (icons[name]) {
      const SpecifiedIcon = icons[name].icon

      if (!isBrandedFaresVariant) {
        return included ? (
          <SpecifiedIcon name={name} size={size} color='black' />
        ) : (
          <StrikeThrough>
            <SpecifiedIcon name={name} size={size} color='black' />
          </StrikeThrough>
        )
      }

      const baseIcon = (
        <SpecifiedIcon
          name={icons[name].attributeName}
          size={size}
          color={ICON_COLOR}
          title={description}
          data-testid={description}
        />
      )
      return (
        <Flex alignItems={'center'}>
          <Hide xs>
            {this.state.showTooltip && AmenityIcon.getTooltip(description, inclusion, useSentenceText)}
          </Hide>
          <Flex
            alignItems='center'
            className={'amenity-icon-wrap'}
            data-testid={`amenity-icon-${name.toLowerCase()}`}
            onFocus={!disableTooltip && this.showTooltip}
            onBlur={!disableTooltip && this.hideTooltip}
            onMouseOver={!disableTooltip && this.showTooltip}
            onMouseOut={!disableTooltip && this.hideTooltip}
            role={'button'}
            aria-label={`${description} ${inclusion}`}
          >
            {inclusion === INCLUSION_RULES.INCLUDED.name && baseIcon}
            {inclusion === INCLUSION_RULES.CHARGEABLE.name && (
              <ComposedIcon
                widthPx={size}
                icon={baseIcon}
                description={description}
                badgeIcon={<DollarCircle color='secondary.base' />}
              />
            )}
            {inclusion !== INCLUSION_RULES.INCLUDED.name && inclusion !== INCLUSION_RULES.CHARGEABLE.name && (
              <Box ml='-1px'>
                <StrikeThrough
                  allowHorizontalAlignment={allowHorizontalAlignment}
                  color={strikeThroughColor}
                  strokeWidth={'2px'}
                >
                  {baseIcon}
                </StrikeThrough>
              </Box>
            )}
          </Flex>
        </Flex>
      )
    }

    return null
  }
}

AmenityIcon.defaultProps = {
  size: 20,
  theme: airTheme,
  inclusion: 'NOT_INCLUDED',
  disableTooltip: false,
}

AmenityIcon.propTypes = {
  name: PropTypes.string,
  included: PropTypes.bool,
  isBrandedFaresVariant: PropTypes.bool,
  inclusion: PropTypes.string,
  size: PropTypes.number,
  description: PropTypes.string,
  strikeThroughColor: PropTypes.string,
  allowHorizontalAlignment: PropTypes.bool,
  useSentenceText: PropTypes.bool,
  disableTooltip: PropTypes.bool,
}
